module.exports = __webpack_public_path__ + "img/icon-cookie.6e2fb48f.svg";